<template>
  <page>
    <template slot="title">Энергоаудит</template>
    <template slot="section">
      <columns>
        <column size="10">
          <p>Независимое всестороннее обследование энергетических систем и оборудования с целью определения:</p>
          <ol>
            <li>их фактического состояния и соответствия действующим нормативам;</li>
            <li>резервов энергосбережения и повышения энергоэффективности;</li>
            <li>программы энергосберегающих мероприятий, включая:</li>
          </ol>
          <ul>
            <li>Сокращение расходования электроэнергии;</li>
            <li>Повышение энергоэффективности и надежности энергооборудования и систем;</li>
          </ul>
          <p>Для потребителей энергетический аудит – ценнейший инструмент принятия решений в области организации и обеспечения качественного, надежного, энергоэффективного и безопасного функционирования предприятия.</p>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-12.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
    }
  }
}
</script>



// WEBPACK FOOTER //
// Audit.vue?6b6e848a